import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../../src/styles/login.scss";
import axios from "axios";
import LoginNavbar from "./loginNavbar";
import { apiHost } from "../api/apiClient";
import { Helmet } from "react-helmet";
import visionTrakLogo from "../Assets/visiontrak-logo-colored.png";
import TurnstileWidget from "./turnstileWidget";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      emailError: false,
      submitMessage: "",
      submitError: "",
      submitting: false,
      turnstileToken: "",
      securityCheckReady: false,
    };

    this.turnstileWidget = React.createRef();
  }

  resetTurnstile = () => {
    if (this.turnstileWidget.current) this.turnstileWidget.current.reset();

    this.setState({ turnstileToken: "", securityCheckReady: false });
  };

  handleEmailChange = (evt) => {
    this.setState({
      email: evt.target.value,
      emailError: false,
      submitMessage: "",
      submitError: "",
    });
  };

  handleSubmit = async (evt) => {
    evt.preventDefault();

    if (!this.state.email) {
      this.setState({ emailError: true });
      return;
    }

    if (!this.state.turnstileToken) {
      this.setState({ submitError: "Please complete the security check." });
      return;
    }

    this.setState({ submitting: true, submitMessage: "", submitError: "" });

    try {
      const response = await axios.post(`${apiHost}/api/auth/ForgotPassword`, {
        Email: this.state.email,
        TurnstileToken: this.state.turnstileToken,
      });

      this.setState({
        submitMessage: response.data || "If an account exists for that email, password reset instructions have been sent.",
        submitError: "",
        submitting: false,
      });
      this.resetTurnstile();
    } catch (e) {
      const responseMessage = e.response && typeof e.response.data === "string"
        ? e.response.data
        : "We could not send reset instructions right now. Please try again later.";

      this.setState({
        submitMessage: "",
        submitError: responseMessage,
        submitting: false,
      });
      this.resetTurnstile();
    }
  };

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Forgot Password</title>
        </Helmet>
        <LoginNavbar></LoginNavbar>

        <div className="loginPage">
          <video
            className="loginVideoBackground"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            aria-hidden="true"
          >
            <source src="/videos/login-background.webm" type="video/webm" />
            <source src="/videos/login-background.mp4" type="video/mp4" />
          </video>
          <div className="loginVideoOverlay"></div>
          <div className="loginWrapper">
            <div className="loginHeader">
              <img className="loginLogo" src={visionTrakLogo} alt="VisionTrak" />
              <h1>Reset password.</h1>
              <p>Enter your email and we will send reset instructions.</p>
              {this.state.submitMessage && (
                <p className="success-msg">{this.state.submitMessage}</p>
              )}
              {this.state.submitError && (
                <p className="error-msg">{this.state.submitError}</p>
              )}
            </div>
            <div className="loginForm">
              <form className="form" onSubmit={this.handleSubmit}>
                <div className="loginInput">
                  <div className="loginInputLeft">
                    <label>Email</label>
                  </div>
                  <div className="loginInputRight">
                    <input
                      type="email"
                      data-test="email"
                      value={this.state.email}
                      onChange={this.handleEmailChange}
                      autoComplete="username"
                    />
                    <div className="error-msg">
                      {this.state.emailError && (
                        <p>The email field is required.</p>
                      )}
                    </div>
                  </div>
                </div>
                <TurnstileWidget
                  ref={this.turnstileWidget}
                  action="forgot-password"
                  onVerify={(token) => this.setState({ turnstileToken: token, securityCheckReady: true, submitError: "" })}
                  onExpire={() => this.setState({ turnstileToken: "", securityCheckReady: false })}
                  onError={(message) => this.setState({ turnstileToken: "", securityCheckReady: false, submitError: message })}
                />
                <div className="loginBtnContainer">
                  <div className="loginBtn">
                    <input
                      type="submit"
                      value={this.state.submitting ? "Sending..." : "Send reset link"}
                      disabled={this.state.submitting || !this.state.securityCheckReady}
                    />
                  </div>
                </div>
                <div className="loginHelpLink">
                  <Link to="/login">Back to login</Link>
                </div>
              </form>
            </div>
            <div className="loginFooter">
              <p>&copy; {new Date().getFullYear()} - Vision Trak Rentals Pty Ltd </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ForgotPassword;
